import { AuthService } from '../services/auth.service';

/** True when the signed-in user (from the login token) is the given user id. Used to mirror server maker-checker refusals. */
export function isCurrentUser(userId?: string | null): boolean {
    if (!userId) return false;
    return AuthService.getCurrentUser()?.userId === userId;
}
